import React, { useState } from "react";
import "./Contact.css";
import { Button } from "@mui/material";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaGoogle,
  FaLocationArrow,
  FaLandmark,
  FaPhone,
  FaMailBulk,
  FaMailchimp,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";
import {
  MdOutlineTravelExplore,
  MdOutlineSupportAgent,
  MdStar,
} from "react-icons/md"; // Icons for trust signals
import { FaTrophy } from "react-icons/fa"; // Icon for years in business
// New Import: Google Icon
import { FcGoogle } from "react-icons/fc";
// IMPORT YOUR HERO IMAGE - Replace with your actual path
import ContactHeroImage from "../assets/contactBanner.png";

function Contact() {
  // 1. Add state to capture form inputs
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  // Handler for input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // 2. Handle the submit action
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevents the default form submission behavior

    // Check if required fields are filled
    if (!formData.name || !formData.email || !formData.message) {
      alert("Please fill in Name, Email, and Message.");
      return;
    }

    const recipientEmail = "mdtravels30@gmail.com";

    // Encode the form data for the mailto link
    const subject = encodeURIComponent(
      `Inquiry from ${formData.name}: ${formData.subject}`
    );
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    );

    // Construct the mailto link
    const mailtoLink = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;

    // Open the user's default email client
    window.location.href = mailtoLink;

    // Optional: Clear the form after "submission"
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="contact-wrapper">
      {/* 1. HERO BANNER - Full Width */}
      <div className="hero-banner-container">
        <img
          src={ContactHeroImage}
          alt="International Destinations Banner - World Landmarks"
          className="hero-banner-image"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src =
              "https://placehold.co/1920x450/004a80/ffffff?text=Discover+Your+Next+Adventure";
          }}
        />
        <div className="hero-content-overlay">
          <h1 className="hero-title">Contact US</h1>
          <p className="hero-subtitle">Where Exceptional Journeys Begin</p>
        </div>
      </div>

      {/* Existing Content Container */}
      <div className="contact-container">
        <div className="contact-info">
          <h2>Get in Touch With Us</h2>
          <ul>
            <li>
              📍 &nbsp;&nbsp;K M Centre, Opp. STC College, <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Near Police Station,
              Banahatti, KA, 587311
            </li>
            <li>
              📞&nbsp;&nbsp;
              <a href="tel:+9178337864840">+91 7337864840</a>
            </li>
            <li>
              ✉️&nbsp;&nbsp;
              <a href="mailto:mdtravels3o@gmail.com">mdtravels30@gmail.com</a>
            </li>
            <li>⏰ &nbsp;Monday – Saturday : 9:00 AM – 6:00 PM</li>
          </ul>
          <p>
            Follow Us On &nbsp;&nbsp;&nbsp;&nbsp;
            <a
              href="https://www.instagram.com/mdtravels_2025?igsh=MW9ydHpjNW9qNDc5aw=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={28} color="red" className="instaIcon" />
            </a>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a
              href="https://maps.app.goo.gl/Vbmamh2BugEwJhtw9"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGoogle size={24} color="#2a6e98ff" className="instaIcon" />
            </a>
          </p>

          <div className="map">
            {/* Note: I've kept the original iframe src, but in a real-world scenario, you should use the actual Google Maps embed link. */}

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15529506.356995901!2d65.42490854999998!3d14.844020700772464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc7315da7da3c93%3A0x1518e45bc83158ed!2sM%20D%20Tours%20and%20Travels!5e1!3m2!1sen!2sin!4v1762847914709!5m2!1sen!2sin"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
              height="220"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>

        <div className="contact-form">
          <h2>We'd love to hear from you</h2>
          <p>Send us a message and we'll respond as soon as possible</p>
          {/* 3. Attach handleSubmit to the form's onSubmit event */}
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Name"
              name="name" // Added name attribute
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              placeholder="Email"
              name="email" // Added name attribute
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              placeholder="Subject"
              name="subject" // Added name attribute
              value={formData.subject}
              onChange={handleChange}
            />
            <textarea
              placeholder="Message"
              rows="4"
              name="message" // Added name attribute
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <Button
              type="submit" // Key: Set type="submit" to trigger the form's onSubmit
              variant="contained" // Optional: Added to make it look more like a button
              style={{
                backgroundImage: "linear-gradient(to right, #183048, #356da5)",
              }}
            >
              Submit
            </Button>
          </form>
        </div>
      </div>
      {/* Trust Signals & Social Proof */}
      <div className="trust-and-social-container">
        {/* 1. Trust Signals / Highlights */}
        <div className="trust-signals">
          <div className="trust-signal-item">
            <MdOutlineTravelExplore className="trust-icon" />
            <p>
              Trusted by 5,000+ <br />
              Travelers
            </p>
          </div>
          <div className="trust-signal-item">
            <FaTrophy className="trust-icon" />
            <p>
              4+ Years in <br />
              Global Tourism
            </p>
          </div>
          <div className="trust-signal-item">
            <MdOutlineSupportAgent className="trust-icon" />
            <p>
              24/7 <br />
              Support
            </p>
          </div>
        </div>

        {/* 2. Social Proof Snippet (⭐ 4.8 Google Rating) */}
        <div className="social-proof">
          <p className="social-proof-text">
            <FcGoogle className="google-icon" /> Rated 4.8/5.0 on Google
            <div className="rating-stars-container">
              {[...Array(5)].map((_, i) => (
                <MdStar
                  key={i}
                  className="rating-star"
                  style={{ color: i < 4.8 ? "#FFC107" : "#e0e0e0" }}
                />
              ))}
            </div>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
